<div class="fs-2 mb-2 text-primary">
  Parametry produktu
</div>

<div class="border p-3 mb-4">

  <form [formGroup]="calculationForm">

    <div class="row">

      <div class="col-12 col-md-6">
        <label for="height" class="form-label">Výška</label>
        <div class="input-group mb-3 mb-4">
          <input id="height" class="form-control" [formControlName]="'height'" placeholder="0" type="number">
          <span class="input-group-text" id="basic-addon2">cm</span>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <label for="width" class="form-label">Šířka</label>
        <div class="input-group mb-3 mb-4">
          <input id="width" class="form-control" [formControlName]="'width'" placeholder="0" type="number">
          <span class="input-group-text" id="basic-addon2">cm</span>
        </div>
      </div>

    </div>

    <label for="count" class="form-label">Počet</label>
    <div class="input-group mb-3 mb-4">
      <input id="count" class="form-control" [formControlName]="'count'" placeholder="0" type="number">
      <span class="input-group-text" id="basic-addon2">ks</span>
    </div>

  </form>

</div>

<div class="fs-2 mb-2 text-primary">
  Doplňkové služby
</div>

<div class="border p-3 mb-4">

  <div class="row" *ngIf="services$ | async as services; else servicesSkeleton">
    <div class="col-12 col-md-6 col-lg-4" *ngFor="let service of services; let i = index">


      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" [checked]="checkParam(service.id)" [id]="'checkbox'+i" (change)="onCheckboxChange($event, service.id)">
        <label class="form-check-label pl-4" [for]="'checkbox'+i">
          <div class="fw-bold">{{service.name}}</div>
          <div class="">
            <small>
              {{service.description}}
            </small>
          </div>
        </label>
      </div>

    </div>
  </div>

  <ng-template #servicesSkeleton>
    <div>
      <div class="skeleton-loader bg-secondary-subtle rounded mb-4" style="height:30px">
      </div>
      <div class="skeleton-loader bg-secondary-subtle rounded mb-4" style="height:30px">
      </div>
      <div class="skeleton-loader bg-secondary-subtle rounded mb-4" style="height:30px">
      </div>
      <div class="skeleton-loader bg-secondary-subtle rounded mb-4" style="height:30px">
      </div>
    </div>
  </ng-template>

</div>

<div class="d-grid">
  <button class="btn btn-lg w-full rounded-pill btn-primary btn-block" (click)="onSubmit()">Spočítat</button>
</div>
